
import { useEffect, useState, useCallback } from "react";
import SwipeableButton from "../../../components/_input/_swipeableButton";
import Joi from "joi";
import { formValidate, GetMessages } from "../../../utils/validation";
import PopupWithHeading from "../../../components/popupWithHeading";
import { getData, User_Data_Key } from "../../../utils/localStorageManager";
import config from '../../../configuration/config.json'
import axios from "axios";
import { toast } from "react-toastify";
import { includes } from "lodash";
import AddressSelection from "./addressSelection";
import BranchlessSelection from "./branchlessSelection";
import { useTranslation } from "react-i18next";
function CarBuyOrder({ dataCar, onSuccess }) {
    const [error, setError] = useState({});
    const { t: trans, i18n } = useTranslation(["mobileHeading", "mobileCommon", "new", "info", 'error']);
    let lang = localStorage.getItem("i18nextLng");
    const languageDir = "language-" + lang;
    const [block, setBlock] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [optionType, setOptionType] = useState(null);
    const [optionTitle, setOptionTitle] = useState('');
    const [errors, setErrors] = useState(true);
    const [requestForm, setRequestForm] = useState({


        buyType: 'online',
        paymentType: 'cash',
        delevryType: 'branch',
        delevryData: null


    });

    const schema = Joi.object({
        buyType: Joi.string().required().messages(GetMessages()),
        paymentType: Joi.string().required().messages(GetMessages()),
        delevryType: Joi.string().required().messages(GetMessages()),
        delevryData: Joi.string().required().messages(GetMessages())


    });
    // const onSuccess = () => {
    //     console.log('Yay! Swipe Success');
    // }
    useEffect(() => {

        console.log("dataCar>>>>>>>>>>>>.:", dataCar);


        console.log("requestForm:", requestForm);

      

        const result = formValidate(schema, requestForm) ?? {};
        let unspesificErrors = null;
        console.log("result:", result);
        let newErrors = {};

        newErrors = unspesificErrors ? removeUnspecificError(result, unspesificErrors) : result;
        setError(newErrors);
        if (Object.keys(newErrors).length === 0) {

            setErrors(false);
        } else {

            setErrors(true);
        }



    }, [requestForm]);


    const handelValdating =()=>{
        console.log("handelValdating:");

        if (requestForm.buyType == "online" && requestForm.paymentType == "cash") {
            if (!dataCar?.showPric) {
                toast.warning(trans("new:not_available_to_buy_online"));
                return
            }
        }
        if (requestForm?.delevryType == "branch") {
            if (!requestForm?.delevryData) {
                toast.warning(trans("new:please_select_branch"));
                return
            }

        } else {

            if (!requestForm?.delevryData) {
                toast.warning(trans("new:please_select_the_title"));
                return;
            }


        }


    }


    // to sumbit finance car order
    const handleSubmit = () => {
        try {

            if (requestForm.buyType == "online" && requestForm.paymentType == "cash") {
                if (!dataCar?.showPric) {
                    return
                }
            }
            if (requestForm?.delevryType == "branch") {
                if (!requestForm?.delevryData) {
                    return
                }
    
            } else {
    
                if (!requestForm?.delevryData) {
                    return;
                }
    
    
            }

            console.log("requestForm:", requestForm);
            setBlock(true);

            console.log("handleSubmit:", requestForm);
            console.log("schema:", schema);
            const result = formValidate(schema, requestForm) ?? {};
            let unspesificErrors = null;
            console.log("result:", result);
            let newErrors = {};

            newErrors = unspesificErrors ? removeUnspecificError(result, unspesificErrors) : result;
            setError(newErrors);
            if (Object.keys(newErrors).length === 0) {

                const sucssData = { ...requestForm, ...dataCar };
                console.log("sucssData:", sucssData);


                if (sucssData.buyType == "online" && sucssData.paymentType == "cash") {
                    if (dataCar?.showPric) {
                        PaymentMAin(sucssData);

                    } else {

                        toast.warning(trans("new:not_available_to_buy_online"));
                        return
                    }

                } else {
                    if (onSuccess)
                        onSuccess(sucssData);

                }


            } else {

            }
        } catch (err) {
            console.log(err);
        }
    };


    const getUserIpAddress = async () => {
        let currentIpv4Info = {};
        try {
            const response = await axios.get('https://geolocation-db.com/json/');
            if (response.status === 200) {
                const { IPv4, country_code, country_name } = response.data;
                currentIpv4Info.ipv4 = IPv4;
                currentIpv4Info.countryCode = country_code;
                currentIpv4Info.countryName = country_name;
            }
        } catch (error) {
            console.log(error);
        }
        return currentIpv4Info;
    };
    //PaymentMAin
    async function PaymentMAin(data) {

        var _userData = "";
        var user_id = "";

        try {
            _userData = JSON.parse(getData(User_Data_Key, true));
            user_id = _userData?.userId;
        } catch (error) {

            toast.error(trans("new:login_first"), {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            return
        }

        if (!block) {

            try {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                console.log('PaymentMAin1111');
                const { ipv4 } = await getUserIpAddress();
                console.log('ipv4:', ipv4);
                var raw = {

                    "URL": window.location.origin + "/store/paymentAlert/",
                    "Product": {
                        id: data.ProductId,
                        quantity: 1,
                        colorID: data.colorID ? data.colorID : null,
                        Type: 1,
                        price: data.minPrice,
                        CartID: null,
                        VIN: null,
                        MiniDownPayment: data.minPrice
                    },
                    "UserID": parseInt(user_id),
                    "customerDetails": {
                        "IP": ipv4
                    },
                    "DataAmount": {
                        "FinalTotal": data.minPrice,
                        "AmountShipping": 0,
                        "SubAmountTotal": data.minPrice,
                        "TotalTaxAmount": data.Tax,
                        "TotalDiscount": data.discountPrice,
                        "MiniDownPayment": data.minPrice
                    },
                    "PaymentAmount": 0,
                    "TypePaymnet": {
                        "IsReservation": false,
                        "IsPayment": true,
                        "MethodPayment": "online"
                    },
                    "DeliveryType": {
                        "ByBranch": data.delevryType == "branch",
                        "ByLocation": data.delevryType == "address"
                    },
                    "DeliveryData": {
                        "InfoBranch": data.delevryType == "branch" ? data.delevryData : null,
                        "InfoLocation": data.delevryType == "address" ? "Abqa-SAU" : null
                    },
                    "CobonData": {
                        "Code": null,
                        "ID": null,
                        "Amount": null
                    },
                    "RefrancePayment": null,
                    "status": 1
                };


                console.log('raw:', raw);
                axios.request({
                    url: config.paymentURL + "/api/Payment/Payment", headers: myHeaders,
                    data: raw, method: "POST", responseType: "json"
                }).then(response => {
                    console.log('api/Payment/Payment respons:', response);

                    if (response.data.URL_Paytabs) {
                        window.location.href = response.data.URL_Paytabs;
                    } else {
                        toast.error(trans("error:unknown_failure"));
                        return

                    }

                    // window.open(response.data.URL_Paytabs);
                    //  window.open(response.data.callback);
                    // window.location.href = response.data.callback;
                    // window.location.href = (`/${lang}/purchaseMsg?q=${response.data.URL_Paytabs}`)
                    //clear();

                }
                ).then((response) => {
                    console.log('response2', response);
                }).catch(error => {
                    console.log('error', error)
                    toast.error(trans("error:unknown_failure"));

                });
            } catch (error) {
                console.log('error', error)
                toast.error(trans("error:unknown_failure"));
            }
        }

    }


    const popupSectionCallback = useCallback(() => {

        let fragment = <></>;
        switch (optionType) {
            case 0:


                fragment = <BranchlessSelection
                    submitRequest={(data) => {

                        setShowPopup(false);
                        const val = { ...requestForm };
                        val.delevryData = data?.SiteID;

                        try {
                            val.delevryData = data?.SiteID;
                        } catch (error) {
                            val.delevryData = "";
                        }
                        setRequestForm(val);

                    }}
                />

                break;

            case 1:
                fragment = <AddressSelection
                    nameSubmit={trans("new:complete_order")}
                    submitRequest={(data) => {

                        const val = { ...requestForm };
                        try {
                            val.delevryData = data?.City;
                        } catch (error) {
                            val.delevryData = "";
                        }

                        setRequestForm(val);
                        setShowPopup(false);
                    }}
                />
                break;
        }
        return <div className="my-20">
            {fragment}

        </div>;
    }, [optionType, optionTitle]);

    // to remove the unneeded props
    const removeUnspecificError = (errorList, values = []) => {
        let errorResult = {};
        if (values?.length > 0) {
            const lowerValues = values.map(item => {
                return item.toLowerCase()
            });
            Object.assign(errorResult, errorList);
            if (errorList) {
                for (let index = 0; index < Object.keys(errorList).length; index++) {
                    const key = Object.keys(errorList)[index];
                    if (includes(lowerValues, key.toLowerCase())) {
                        delete errorResult[key];
                    } else {
                        continue;
                    }
                }
            }
        }
        return errorResult;
    };
    return (
        <section className="jobs-form car-buy-order nice-apply-theme">

            <div className="car-buy-order-top">

                <div className="car-buy-order-top-details ">
                    <h1 className="text-right text-40 mt-2  nice-apply-theme">{dataCar?.name}</h1>
                    <h4 className="text-right text-20 mt-2 ">{trans("new:outer_color")} :<span className="text-20 mt-2 ">{dataCar?.colorName}</span></h4>
                    {/* <h4 className="text-right text-20 mt-2 ">{"الون الداخلي:"}<span className="text-20 mt-2 ">{dataCar?.colorName}</span></h4> */}
                </div>

                <div className="car-buy-order-top-img ">
                    <img src={dataCar?.img ? "data:image/png;base64," + dataCar?.img : "/assets/images/default.png"} />

                </div>


            </div>

            <div className={`car-buy-order-box nice-apply-theme ${error?.buyType && 'border-danger'}`}>
                <span className="text-34 text-bold  text-super-gray nice-apply-theme">{trans("new:buy_method")}</span>

                <div className={"input nice-apply-theme " + languageDir} style={{ marginBottom: '0rem' }}>


                    <label className={"input-radio   text-24 text-bold text-gray"}>
                        <img className=" pt-1" src="/assets/icons/deleviry.svg" alt="" />   {trans("new:online")}
                        <input radioGroup={""}

                            onChange={() => {

                                if (dataCar?.showPric) {

                                    if (!block) {
                                        const val = { ...requestForm };
                                        val.buyType = "online";
                                        val.paymentType = "cash";
                                        console.log("buyType:", val)
                                        setRequestForm(val);
                                    }

                                } else {
                                    toast.warning(trans("new:not_available_to_buy_online"));
                                    return
                                }

                            }}
                            id="primary"
                            value={"online"} name={"selected1"} className={""} checked={(("online" != requestForm.buyType) ? false : true)} type="radio" />

                    </label>
                    <label className={"input-radio  text-24 text-bold text-gray"}>
                        <img className=" pt-1" src="/assets/icons/deleviry.svg" alt="" />   {trans("info:purchase_order")}
                        <input radioGroup={""}


                            onChange={() => {
                                if (!block) {
                                    const val = { ...requestForm };
                                    val.buyType = "order";
                                    val.paymentType = "finance";
                                    if (!val.delevryData)
                                        val.delevryData = "finance"
                                    console.log("buyType:", val)
                                    setRequestForm(val);
                                }
                            }}

                            id="primary"

                            value={"order"} name={"selected1"} className={""} checked={(("order" != requestForm.buyType) ? false : true)} type="radio" />
                    </label>

                </div>

            </div>

            <div className={`car-buy-order-box nice-apply-theme ${error?.paymentType && 'border-danger'}`}>
                <span className="text-34 text-bold text-super-gray nice-apply-theme">{trans("new:pay_method")}</span>
                <div className={"input nice-apply-theme " + languageDir} style={{ marginBottom: '0rem' }}>

                    <label className={"input-radio   text-24 text-bold  text-gray"}>
                        <img className=" pt-1" src="/assets/icons/deleviry.svg" alt="" />   {trans("new:cash")}
                        <input radioGroup={""}

                            onChange={() => {
                                if (!block) {
                                    const val = { ...requestForm };
                                    val.paymentType = "cash";
                                    val.buyType = "online";
                                    if (val.delevryData == "finance")
                                        val.delevryData = null;
                                    console.log("paymentType:", val)
                                    setRequestForm(val);
                                }
                            }}
                            id="primary"
                            value={"cash"} name={"selected2"} className={""} checked={(("cash" != requestForm.paymentType) ? false : true)} type="radio" />

                    </label>
                    <label className={"input-radio  text-24 text-bold text-gray"}>
                        <img className=" pt-1" src="/assets/icons/deleviry.svg" alt="" />   {trans("mobileCommon:finance")}
                        <input radioGroup={""}

                            onChange={() => {
                                if (!block) {
                                    const val = { ...requestForm };
                                    val.paymentType = "finance";
                                    val.buyType = "order";
                                    if (!val.delevryData)
                                        val.delevryData = "finance"
                                    console.log("paymentType:", val)
                                    setRequestForm(val);
                                }
                            }}
                            id="primary"
                            value={"finance"} name={"selected2"} className={""} checked={(("finance" != requestForm.paymentType) ? false : true)} type="radio" />
                    </label>

                </div>
            </div>

            <div className={`car-buy-order-box nice-apply-theme ${error?.delevryType && 'border-danger'}`}>
                <span className="text-34 text-bold text-super-gray nice-apply-theme">{trans("new:delivery_method")}</span>
                <div className={"input nice-apply-theme " + languageDir} style={{ marginBottom: '0rem' }}>

                    <label className={"input-radio text-24 text-bold text-gray"}>
                        <img className=" pt-1" src="/assets/icons/deleviry.svg" alt="" />   {trans("new:delivery")}
                        <input radioGroup={""}
                            onClick={() => {

                                if (!block) {
                                    setOptionTitle(trans("new:address"));
                                    setOptionType(1);
                                    setShowPopup(true);

                                }
                            }}
                            onChange={() => {


                                if (!block) {

                                    const val = { ...requestForm };
                                    val.delevryType = "address";
                                    console.log("delevryType:", val)
                                    setRequestForm(val);
                                }
                            }}
                            id="primary"

                            value={"address"} name={"selected3"} className={""} checked={(("address" != requestForm.delevryType) ? false : true)} type="radio" />

                    </label>
                    <label className={"input-radio  text-24 text-bold text-gray"}>
                        <img className="pt-1" src="/assets/icons/deleviry.svg" alt="" />   {trans("mobileCommon:branch_delivery")}
                        <input radioGroup={""}

                            onClick={() => {

                                if (!block) {
                                    setOptionTitle(trans("mobileCommon:branch_delivery"));
                                    setOptionType(0);
                                    setShowPopup(true);

                                }
                            }}
                            onChange={() => {
                                if (!block) {
                                    const val = { ...requestForm };
                                    val.delevryType = "branch";
                                    console.log("delevryType:", val)
                                    setRequestForm(val);
                                }
                            }}
                            id="primary"
                            value={"branch"} name={"selected3"} className={""} checked={(("branch" != requestForm.delevryType) ? false : true)} type="radio" />
                    </label>

                </div>
            </div>


            <div className='swipeable-button-block'>
                <SwipeableButton
                    block={errors}
                    onValdating ={handelValdating}
                    onSuccess={handleSubmit} color='#868383'
                    text={errors ? trans("new:please_complete_the_information")
                        : trans("new:swipe_to_complete_the_order")}
                    text_unlocked={trans("new:the_request_is_being_processed")} />
            </div>

            <div className="car-buy-order-note">

                <h3 className="text-30 ">
                    {trans("info:privecy_part1") + " "}

                    <a href="#" className="text-30 text-info">
                        {trans("info:privecy_part2") + " "}
                    </a>

                    {trans("info:privecy_part3")} </h3>

            </div>


            <PopupWithHeading

                backButton={true}
                show={showPopup}
                title={optionTitle}
                onStatusChange={(status) => {
                    setShowPopup(false);
                }}
            >
                {popupSectionCallback()}
            </PopupWithHeading>
        </section>
    );
}

export default CarBuyOrder;
